import VideoPlayer from "../components/VideoPlayer";
import { getSinglePodcast, podcastViewed } from "../apiCalls/podcasts/api_v1_podcasts";
import GamezGuides from "../components/GamezGuides";
import {React, useState, useEffect} from "react";
import {Box, CircularProgress, Typography} from "@mui/material";
import { useLocation } from "react-router-dom";
import { hasRatedVideo } from "../apiCalls/feedback/feedback";
import RatingDialog from '../components/RatingDialog';

function Podcast () {
    const [podcast, setPodcast] = useState(null);
    const [loading, setLoading] = useState(false);
    const [ratingDialogOpen, setRatingDialogOpen] = useState(false);
    const [ratingShown, setRatingShown] = useState(false);
    const [videoRef, setVideoRef] = useState(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const podcastUuid = queryParams.get('uuid');
    const skillLevel = sessionStorage.getItem("skillLevel");

    useEffect(() => {
        document.title = 'Game Guidez | Gamez Academy';
    }, [])

    const checkRatingAt17Percent = async () => {
        const ratingKey = `ratingShown_${podcastUuid}`;
        const alreadyShown = sessionStorage.getItem(ratingKey);
        
        if (ratingShown || alreadyShown) return; // Only show once per podcast
        
        setRatingShown(true);
        sessionStorage.setItem(ratingKey, 'true');
        setRatingDialogOpen(true);
    };

    useEffect(() => {
        const fetchPodcast = async () => {
            console.log(podcastUuid);
            try {
                const response = await podcastViewed(podcastUuid);
                if (response.status === 200) {
                    console.log(response)
                    setPodcast(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching podcast:', error);
            }
        };
        
        // Reset rating state when podcast changes
        setRatingShown(false);
        setRatingDialogOpen(false);
        
        fetchPodcast();
    }, [podcastUuid]);

    return (
        <Box
            sx={{
                p: 2,
                color: 'white',
            }}
        >
            {podcast ? (
                <>
                    <VideoPlayer
                        videoUrl={podcast.video}
                        onTimeUpdate={(currentTime, duration) => {
                            const watchedPercentage = (currentTime / duration) * 100;
                            const ratingKey = `ratingShown_${podcastUuid}`;
                            const alreadyShown = sessionStorage.getItem(ratingKey);
                            
                            if (watchedPercentage >= 17 && !ratingShown && !alreadyShown) {
                                checkRatingAt17Percent();
                            }
                        }}
                        onVideoRef={(ref) => setVideoRef(ref)}
                    />
                    {podcast.title && (
                        <Typography 
                            variant="h6" 
                            sx={{ 
                                color: 'white', 
                                mt: 1,
                                mb: 2, 
                                fontWeight: 600,
                                textAlign: 'left'
                            }}
                        >
                            {podcast.title}
                        </Typography>
                    )}
                </>
            ) : (
                <CircularProgress />
            )}

            <Box sx={{ 
                width: '100%', 
                height: '1px', 
                backgroundColor: 'rgba(255, 255, 255, 0.2)', 
                my: 3 
            }} />

            <GamezGuides skillLevel={skillLevel}/>
            
            <RatingDialog 
                open={ratingDialogOpen}
                onClose={() => {
                    setRatingDialogOpen(false);
                    if (videoRef && videoRef.paused) {
                        videoRef.play().catch(() => {});
                    }
                }}
                onOpen={() => {
                    if (videoRef && !videoRef.paused) {
                        videoRef.pause();
                    }
                }}
                contentId={podcastUuid}
                contentType="podcast"
            />
        </Box>
    );
}

export default Podcast;